var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vi-school"},[_c('keep-alive',[_c(_vm.currentComponent,{tag:"component",attrs:{"swap-component":_vm.swapComponent}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }